import { ExpandMore } from "@mui/icons-material";
import { Accordion, AccordionDetails, AccordionSummary, Box, Typography } from "@mui/material";
import { PendingLeaderboardItemContents, PendingLeaderboardItemProps } from "components/events/judging/pending/PendingLeaderboardItem";
import { pendingLeaderboardRowStyles } from "components/events/judging/pending/styles";
import { T } from "components/util/t";
import { mergeSx, Sx } from "utils/sx";

const actionAreaStyles: Sx = ({
    display: "flex",
    flexDirection: "column",
    gap: 1,
});

const accordionStyles: Sx = theme => ({
    boxShadow: theme.shadows.custom[1],
});

const accordionSummaryStyles: Sx = theme => ({
    "&:hover": {
        backgroundColor: theme.palette.background.lowest
    }
});

const accordionDetailsStyles: Sx = theme => ({
    p: theme.spacing(0, 2, 2, 2),
});

export const PendingLeaderboardActionArea: React.FC<React.PropsWithChildren> = ({ children }) => {
    return (
        <Accordion defaultExpanded square disableGutters sx={accordionStyles}>
            <AccordionSummary expandIcon={<ExpandMore color='primary' fontSize='small' />} id="action-area" aria-controls="action-items" sx={accordionSummaryStyles}>
                <Typography variant="label2" color="textSecondary" sx={{ textTransform: "uppercase" }}>Pending Scores</Typography>
            </AccordionSummary>
            <AccordionDetails sx={accordionDetailsStyles}>
                <Box sx={actionAreaStyles}>
                    {children}
                </Box>
            </AccordionDetails>
        </Accordion>
    );
};

const actionItemStyles: Sx = ({
    display: "flex",
    flexDirection: "row",
    cursor: "pointer",
    borderRadius: 0.75,
    overflow: "hidden",

    "& [data-result]": {
        "--callout-display": "flex",
    }
});

const tiedActionItemStyles: Sx = (theme) => ({
    border: `1px solid ${theme.palette.error.main}`,
});

const pendingActionItemStyles: Sx = (theme) => ({
    border: `1px solid ${theme.palette.border.main}`,
});

const tieCalloutStyles: Sx = (theme) => ({
    backgroundColor: theme.palette.error.main,
    color: theme.palette.error.contrastText,
    textOrientation: "upright",
    writingMode: "sideways-lr",
    textAlign: "center",
    padding: theme.spacing(1, 0.25),
    textTransform: "uppercase",
});

export const PendingLeaderboardActionItem: React.FC<PendingLeaderboardItemProps> = (props) => {
    return (
        <Box component="li" sx={mergeSx(actionItemStyles, props.tied ? tiedActionItemStyles : pendingActionItemStyles)} data-testid="pending-leaderboard-action-item" role="button">
            {props.tied && <Typography sx={tieCalloutStyles} variant="label2" color="textContrastText"><T>Tie</T></Typography>}

            <Box sx={pendingLeaderboardRowStyles}>
                <PendingLeaderboardItemContents {...props} />
            </Box>
        </Box>
    );
};
